import { render, staticRenderFns } from "./videodetail.vue?vue&type=template&id=7d59b6ec&scoped=true"
import script from "./videodetail.vue?vue&type=script&lang=js"
export * from "./videodetail.vue?vue&type=script&lang=js"
import style0 from "./videodetail.vue?vue&type=style&index=0&id=7d59b6ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d59b6ec",
  null
  
)

export default component.exports